/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'about',
    path: '/about',
    component: 'layout.base$view.about',
    meta: {
      title: 'about',
      i18nKey: 'route.about',
      icon: 'fluent:book-information-24-regular',
      order: 999
    }
  },
  {
    name: 'analytics',
    path: '/analytics',
    component: 'layout.base',
    meta: {
      title: 'analytics',
      i18nKey: 'route.analytics'
    },
    children: [
      {
        name: 'analytics_business-daily-report',
        path: '/analytics/business-daily-report',
        component: 'view.analytics_business-daily-report',
        meta: {
          title: 'analytics_business-daily-report',
          i18nKey: 'route.analytics_business-daily-report'
        }
      },
      {
        name: 'analytics_daily-report-analysis',
        path: '/analytics/daily-report-analysis',
        component: 'view.analytics_daily-report-analysis',
        meta: {
          title: 'analytics_daily-report-analysis',
          i18nKey: 'route.analytics_daily-report-analysis'
        }
      },
      {
        name: 'analytics_direct-supply-record',
        path: '/analytics/direct-supply-record',
        component: 'view.analytics_direct-supply-record',
        meta: {
          title: 'analytics_direct-supply-record',
          i18nKey: 'route.analytics_direct-supply-record'
        }
      },
      {
        name: 'analytics_measurement-tracking',
        path: '/analytics/measurement-tracking',
        component: 'view.analytics_measurement-tracking',
        meta: {
          title: 'analytics_measurement-tracking',
          i18nKey: 'route.analytics_measurement-tracking'
        }
      },
      {
        name: 'analytics_weighing-record-report',
        path: '/analytics/weighing-record-report',
        component: 'view.analytics_weighing-record-report',
        meta: {
          title: 'analytics_weighing-record-report',
          i18nKey: 'route.analytics_weighing-record-report'
        }
      }
    ]
  },
  {
    name: 'approval',
    path: '/approval',
    component: 'layout.base$view.approval',
    meta: {
      title: 'approval',
      i18nKey: 'route.approval'
    }
  },
  {
    name: 'base-goods',
    path: '/base-goods',
    component: 'layout.base',
    meta: {
      title: 'base-goods',
      i18nKey: 'route.base-goods'
    },
    children: [
      {
        name: 'base-goods_appointment',
        path: '/base-goods/appointment',
        component: 'view.base-goods_appointment',
        meta: {
          title: 'base-goods_appointment',
          i18nKey: 'route.base-goods_appointment'
        }
      },
      {
        name: 'base-goods_inbound',
        path: '/base-goods/inbound',
        component: 'view.base-goods_inbound',
        meta: {
          title: 'base-goods_inbound',
          i18nKey: 'route.base-goods_inbound'
        },
        children: [
          {
            name: 'base-goods_inbound_create',
            path: '/base-goods/inbound/create',
            component: 'view.base-goods_inbound_create',
            meta: {
              title: 'base-goods_inbound_create',
              i18nKey: 'route.base-goods_inbound'
            }
          }
        ]
      },
      {
        name: 'base-goods_inbound-images',
        path: '/base-goods/inbound-images',
        component: 'view.base-goods_inbound-images',
        meta: {
          title: 'base-goods_inbound-images',
          i18nKey: 'route.base-goods_inbound-images'
        }
      },
      {
        name: 'base-goods_inbound-quality',
        path: '/base-goods/inbound-quality',
        component: 'view.base-goods_inbound-quality',
        meta: {
          title: 'base-goods_inbound-quality',
          i18nKey: 'route.base-goods_inbound-quality'
        }
      },
      {
        name: 'base-goods_inbound-weight',
        path: '/base-goods/inbound-weight',
        component: 'view.base-goods_inbound-weight',
        meta: {
          title: 'base-goods_inbound-weight',
          i18nKey: 'route.base-goods_inbound-weight'
        }
      },
      {
        name: 'base-goods_outbound',
        path: '/base-goods/outbound',
        component: 'view.base-goods_outbound',
        meta: {
          title: 'base-goods_outbound',
          i18nKey: 'route.base-goods_outbound'
        }
      },
      {
        name: 'base-goods_outbound-images',
        path: '/base-goods/outbound-images',
        component: 'view.base-goods_outbound-images',
        meta: {
          title: 'base-goods_outbound-images',
          i18nKey: 'route.base-goods_outbound-images'
        }
      },
      {
        name: 'base-goods_outbound-quality',
        path: '/base-goods/outbound-quality',
        component: 'view.base-goods_outbound-quality',
        meta: {
          title: 'base-goods_outbound-quality',
          i18nKey: 'route.base-goods_outbound-quality'
        }
      },
      {
        name: 'base-goods_outbound-weight',
        path: '/base-goods/outbound-weight',
        component: 'view.base-goods_outbound-weight',
        meta: {
          title: 'base-goods_outbound-weight',
          i18nKey: 'route.base-goods_outbound-weight'
        }
      },
      {
        name: 'base-goods_purchase-waybill',
        path: '/base-goods/purchase-waybill',
        component: 'view.base-goods_purchase-waybill',
        meta: {
          title: 'base-goods_purchase-waybill',
          i18nKey: 'route.base-goods_purchase-waybill'
        }
      },
      {
        name: 'base-goods_sales-waybill',
        path: '/base-goods/sales-waybill',
        component: 'view.base-goods_sales-waybill',
        meta: {
          title: 'base-goods_sales-waybill',
          i18nKey: 'route.base-goods_sales-waybill'
        }
      }
    ]
  },
  {
    name: 'basedata',
    path: '/basedata',
    component: 'layout.base',
    meta: {
      title: 'basedata',
      i18nKey: 'route.basedata'
    },
    children: [
      {
        name: 'basedata_customer',
        path: '/basedata/customer',
        component: 'view.basedata_customer',
        meta: {
          title: 'basedata_customer',
          i18nKey: 'route.basedata_customer'
        }
      },
      {
        name: 'basedata_driver',
        path: '/basedata/driver',
        component: 'view.basedata_driver',
        meta: {
          title: 'basedata_driver',
          i18nKey: 'route.basedata_driver'
        }
      },
      {
        name: 'basedata_formula-lib',
        path: '/basedata/formula-lib',
        component: 'view.basedata_formula-lib',
        meta: {
          title: 'basedata_formula-lib',
          i18nKey: 'route.basedata_formula-lib'
        }
      },
      {
        name: 'basedata_product-name',
        path: '/basedata/product-name',
        component: 'view.basedata_product-name',
        meta: {
          title: 'basedata_product-name',
          i18nKey: 'route.basedata_product-name'
        }
      },
      {
        name: 'basedata_pub-master-corp',
        path: '/basedata/pub-master-corp',
        component: 'view.basedata_pub-master-corp',
        meta: {
          title: 'basedata_pub-master-corp',
          i18nKey: 'route.basedata_pub-master-corp'
        }
      },
      {
        name: 'basedata_pub-master-person',
        path: '/basedata/pub-master-person',
        component: 'view.basedata_pub-master-person',
        meta: {
          title: 'basedata_pub-master-person',
          i18nKey: 'route.basedata_pub-master-person'
        }
      },
      {
        name: 'basedata_supplier',
        path: '/basedata/supplier',
        component: 'view.basedata_supplier',
        meta: {
          title: 'basedata_supplier',
          i18nKey: 'route.basedata_supplier'
        }
      }
    ]
  },
  {
    name: 'batch',
    path: '/batch',
    component: 'layout.base',
    meta: {
      title: 'batch',
      i18nKey: 'route.batch'
    },
    children: [
      {
        name: 'batch_batch-process',
        path: '/batch/batch-process',
        component: 'view.batch_batch-process',
        meta: {
          title: 'batch_batch-process',
          i18nKey: 'route.batch_batch-process'
        }
      }
    ]
  },
  {
    name: 'contact-center',
    path: '/contact-center',
    component: 'layout.base$view.contact-center',
    meta: {
      title: 'contact-center',
      i18nKey: 'route.contact-center'
    }
  },
  {
    name: 'contract',
    path: '/contract',
    component: 'layout.base',
    meta: {
      title: 'contract',
      i18nKey: 'route.contract'
    },
    children: [
      {
        name: 'contract_purchase',
        path: '/contract/purchase',
        component: 'view.contract_purchase',
        meta: {
          title: 'contract_purchase',
          i18nKey: 'route.contract_purchase'
        },
        children: [
          {
            name: 'contract_purchase_detail',
            path: '/contract/purchase/detail',
            component: 'view.contract_purchase_detail',
            meta: {
              title: 'contract_purchase_detail',
              i18nKey: 'route.contract_purchase_detail',
              hideInMenu: true,
              activeMenu: 'contract_purchase'
            }
          }
        ]
      },
      {
        name: 'contract_sales',
        path: '/contract/sales',
        component: 'view.contract_sales',
        meta: {
          title: 'contract_sales',
          i18nKey: 'route.contract_sales'
        }
      },
      {
        name: 'contract_transport',
        path: '/contract/transport',
        component: 'view.contract_transport',
        meta: {
          title: 'contract_transport',
          i18nKey: 'route.contract_transport'
        }
      }
    ]
  },
  {
    name: 'demo-route',
    path: '/demo-route',
    component: 'layout.base',
    meta: {
      title: 'demo-route',
      i18nKey: 'route.demo-route'
    },
    children: [
      {
        name: 'demo-route_child',
        path: '/demo-route/child',
        component: 'view.demo-route_child',
        meta: {
          title: 'demo-route_child',
          i18nKey: 'route.demo-route_child'
        }
      }
    ]
  },
  {
    name: 'energy',
    path: '/energy',
    component: 'layout.base',
    meta: {
      title: 'energy',
      i18nKey: 'route.energy'
    },
    children: [
      {
        name: 'energy_management',
        path: '/energy/management',
        component: 'view.energy_management',
        meta: {
          title: 'energy_management',
          i18nKey: 'route.energy_management'
        }
      }
    ]
  },
  {
    name: 'finance',
    path: '/finance',
    component: 'layout.base',
    meta: {
      title: 'finance',
      i18nKey: 'route.finance'
    },
    children: [
      {
        name: 'finance_purchase-payment',
        path: '/finance/purchase-payment',
        component: 'view.finance_purchase-payment',
        meta: {
          title: 'finance_purchase-payment',
          i18nKey: 'route.finance_purchase-payment'
        }
      },
      {
        name: 'finance_sales-receipt',
        path: '/finance/sales-receipt',
        component: 'view.finance_sales-receipt',
        meta: {
          title: 'finance_sales-receipt',
          i18nKey: 'route.finance_sales-receipt'
        }
      }
    ]
  },
  {
    name: 'function',
    path: '/function',
    component: 'layout.base',
    meta: {
      title: 'function',
      i18nKey: 'route.function',
      icon: 'icon-park-outline:all-application',
      order: 6
    },
    children: [
      {
        name: 'function_hide-child',
        path: '/function/hide-child',
        meta: {
          title: 'function_hide-child',
          i18nKey: 'route.function_hide-child',
          icon: 'material-symbols:filter-list-off',
          order: 2
        },
        redirect: '/function/hide-child/one',
        children: [
          {
            name: 'function_hide-child_one',
            path: '/function/hide-child/one',
            component: 'view.function_hide-child_one',
            meta: {
              title: 'function_hide-child_one',
              i18nKey: 'route.function_hide-child_one',
              icon: 'material-symbols:filter-list-off',
              hideInMenu: true,
              activeMenu: 'function_hide-child'
            }
          },
          {
            name: 'function_hide-child_three',
            path: '/function/hide-child/three',
            component: 'view.function_hide-child_three',
            meta: {
              title: 'function_hide-child_three',
              i18nKey: 'route.function_hide-child_three',
              hideInMenu: true,
              activeMenu: 'function_hide-child'
            }
          },
          {
            name: 'function_hide-child_two',
            path: '/function/hide-child/two',
            component: 'view.function_hide-child_two',
            meta: {
              title: 'function_hide-child_two',
              i18nKey: 'route.function_hide-child_two',
              hideInMenu: true,
              activeMenu: 'function_hide-child'
            }
          }
        ]
      },
      {
        name: 'function_multi-tab',
        path: '/function/multi-tab',
        component: 'view.function_multi-tab',
        meta: {
          title: 'function_multi-tab',
          i18nKey: 'route.function_multi-tab',
          icon: 'ic:round-tab',
          multiTab: true,
          hideInMenu: true,
          activeMenu: 'function_tab'
        }
      },
      {
        name: 'function_request',
        path: '/function/request',
        component: 'view.function_request',
        meta: {
          title: 'function_request',
          i18nKey: 'route.function_request',
          icon: 'carbon:network-overlay',
          order: 3
        }
      },
      {
        name: 'function_super-page',
        path: '/function/super-page',
        component: 'view.function_super-page',
        meta: {
          title: 'function_super-page',
          i18nKey: 'route.function_super-page',
          icon: 'ic:round-supervisor-account',
          order: 5,
          roles: ['R_SUPER']
        }
      },
      {
        name: 'function_tab',
        path: '/function/tab',
        component: 'view.function_tab',
        meta: {
          title: 'function_tab',
          i18nKey: 'route.function_tab',
          icon: 'ic:round-tab',
          order: 1
        }
      },
      {
        name: 'function_toggle-auth',
        path: '/function/toggle-auth',
        component: 'view.function_toggle-auth',
        meta: {
          title: 'function_toggle-auth',
          i18nKey: 'route.function_toggle-auth',
          icon: 'ic:round-construction',
          order: 4
        }
      }
    ]
  },
  {
    name: 'headquarters',
    path: '/headquarters',
    component: 'layout.base',
    meta: {
      title: '总公司视图',
      i18nKey: 'route.headquarters',
      icon: 'material-symbols:corporate-fare',
      order: 1
    },
    children: [
      {
        name: 'headquarters_contracts',
        path: '/headquarters/contracts',
        component: 'view.headquarters_contracts',
        meta: {
          title: 'headquarters_contracts',
          i18nKey: 'route.headquarters_contracts'
        }
      },
      {
        name: 'headquarters_statistics',
        path: '/headquarters/statistics',
        component: 'view.headquarters_statistics',
        meta: {
          title: '数据统计',
          i18nKey: 'route.headquarters_statistics'
        }
      }
    ]
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.home',
      icon: 'mdi:view-dashboard',
      order: 1
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      i18nKey: 'route.iframe-page',
      constant: true,
      hideInMenu: true,
      keepAlive: true
    }
  },
  {
    name: 'inventory',
    path: '/inventory',
    component: 'layout.base',
    meta: {
      title: 'inventory',
      i18nKey: 'route.inventory'
    },
    children: [
      {
        name: 'inventory_check',
        path: '/inventory/check',
        component: 'view.inventory_check',
        meta: {
          title: 'inventory_check',
          i18nKey: 'route.inventory_check'
        }
      },
      {
        name: 'inventory_finished',
        path: '/inventory/finished',
        component: 'view.inventory_finished',
        meta: {
          title: 'inventory_finished',
          i18nKey: 'route.inventory_finished'
        }
      },
      {
        name: 'inventory_material',
        path: '/inventory/material',
        component: 'view.inventory_material',
        meta: {
          title: 'inventory_material',
          i18nKey: 'route.inventory_material'
        }
      },
      {
        name: 'inventory_production',
        path: '/inventory/production',
        component: 'view.inventory_production',
        meta: {
          title: 'inventory_production',
          i18nKey: 'route.inventory_production'
        }
      }
    ]
  },
  {
    name: 'invoice',
    path: '/invoice',
    component: 'layout.base',
    meta: {
      title: 'invoice',
      i18nKey: 'route.invoice'
    },
    children: [
      {
        name: 'invoice_purchase-invoice',
        path: '/invoice/purchase-invoice',
        meta: {
          title: 'invoice_purchase-invoice',
          i18nKey: 'route.invoice_purchase-invoice'
        },
        children: [
          {
            name: 'invoice_purchase-invoice_in',
            path: '/invoice/purchase-invoice/in',
            component: 'view.invoice_purchase-invoice_in',
            meta: {
              title: 'invoice_purchase-invoice_in',
              i18nKey: 'route.invoice_purchase-invoice_in'
            }
          },
          {
            name: 'invoice_purchase-invoice_out',
            path: '/invoice/purchase-invoice/out',
            component: 'view.invoice_purchase-invoice_out',
            meta: {
              title: 'invoice_purchase-invoice_out',
              i18nKey: 'route.invoice_purchase-invoice_out'
            }
          }
        ]
      },
      {
        name: 'invoice_sales-invoice',
        path: '/invoice/sales-invoice',
        component: 'view.invoice_sales-invoice',
        meta: {
          title: 'invoice_sales-invoice',
          i18nKey: 'route.invoice_sales-invoice'
        }
      }
    ]
  },
  {
    name: 'jin-sheng-lan',
    path: '/jin-sheng-lan',
    component: 'layout.base',
    meta: {
      title: 'jin-sheng-lan',
      i18nKey: 'route.jin-sheng-lan'
    },
    children: [
      {
        name: 'jin-sheng-lan_purchase-detail-ledger',
        path: '/jin-sheng-lan/purchase-detail-ledger',
        component: 'view.jin-sheng-lan_purchase-detail-ledger',
        meta: {
          title: 'jin-sheng-lan_purchase-detail-ledger',
          i18nKey: 'route.jin-sheng-lan_purchase-detail-ledger'
        }
      },
      {
        name: 'jin-sheng-lan_sales-detail-ledger',
        path: '/jin-sheng-lan/sales-detail-ledger',
        component: 'view.jin-sheng-lan_sales-detail-ledger',
        meta: {
          title: 'jin-sheng-lan_sales-detail-ledger',
          i18nKey: 'route.jin-sheng-lan_sales-detail-ledger'
        }
      }
    ]
  },
  {
    name: 'ledger',
    path: '/ledger',
    component: 'layout.base',
    meta: {
      title: 'ledger',
      i18nKey: 'route.ledger'
    },
    children: [
      {
        name: 'ledger_purchase-ledger',
        path: '/ledger/purchase-ledger',
        component: 'view.ledger_purchase-ledger',
        meta: {
          title: 'ledger_purchase-ledger',
          i18nKey: 'route.ledger_purchase-ledger'
        }
      },
      {
        name: 'ledger_purchase-ledger-v2',
        path: '/ledger/purchase-ledger-v2',
        component: 'view.ledger_purchase-ledger-v2',
        meta: {
          title: 'ledger_purchase-ledger-v2',
          i18nKey: 'route.ledger_purchase-ledger-v2'
        }
      },
      {
        name: 'ledger_purchase-ledger-v3',
        path: '/ledger/purchase-ledger-v3',
        component: 'view.ledger_purchase-ledger-v3',
        meta: {
          title: 'ledger_purchase-ledger-v3',
          i18nKey: 'route.ledger_purchase-ledger-v3'
        }
      },
      {
        name: 'ledger_purchase-ledger-v3-detail',
        path: '/ledger/purchase-ledger-v3-detail',
        component: 'view.ledger_purchase-ledger-v3-detail',
        meta: {
          title: 'ledger_purchase-ledger-v3-detail',
          i18nKey: 'route.ledger_purchase-ledger-v3-detail'
        }
      },
      {
        name: 'ledger_purchaser-settlement-center-leger-data',
        path: '/ledger/purchaser-settlement-center-leger-data',
        component: 'view.ledger_purchaser-settlement-center-leger-data',
        meta: {
          title: 'ledger_purchaser-settlement-center-leger-data',
          i18nKey: 'route.ledger_purchaser-settlement-center-leger-data'
        },
        children: [
          {
            name: 'ledger_purchaser-settlement-center-leger-data_detail',
            path: '/ledger/purchaser-settlement-center-leger-data/detail',
            component: 'view.ledger_purchaser-settlement-center-leger-data_detail',
            meta: {
              title: 'ledger_purchaser-settlement-center-leger-data_detail',
              i18nKey: 'route.ledger_purchaser-settlement-center-leger-data_detail'
            }
          }
        ]
      },
      {
        name: 'ledger_sales-ledger',
        path: '/ledger/sales-ledger',
        component: 'view.ledger_sales-ledger',
        meta: {
          title: 'ledger_sales-ledger',
          i18nKey: 'route.ledger_sales-ledger'
        }
      },
      {
        name: 'ledger_sales-ledger-v2',
        path: '/ledger/sales-ledger-v2',
        component: 'view.ledger_sales-ledger-v2',
        meta: {
          title: 'ledger_sales-ledger-v2',
          i18nKey: 'route.ledger_sales-ledger-v2'
        }
      },
      {
        name: 'ledger_sales-ledger-v3',
        path: '/ledger/sales-ledger-v3',
        component: 'view.ledger_sales-ledger-v3',
        meta: {
          title: 'ledger_sales-ledger-v3',
          i18nKey: 'route.ledger_sales-ledger-v3'
        }
      },
      {
        name: 'ledger_sales-ledger-v3-detail',
        path: '/ledger/sales-ledger-v3-detail',
        component: 'view.ledger_sales-ledger-v3-detail',
        meta: {
          title: 'ledger_sales-ledger-v3-detail',
          i18nKey: 'route.ledger_sales-ledger-v3-detail'
        }
      }
    ]
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'manage',
    path: '/manage',
    component: 'layout.base',
    meta: {
      title: 'manage',
      i18nKey: 'route.manage',
      icon: 'carbon:cloud-service-management',
      order: 9,
      roles: ['R_ADMIN']
    },
    children: [
      {
        name: 'manage_approval-admin',
        path: '/manage/approval-admin',
        component: 'view.manage_approval-admin',
        meta: {
          title: 'manage_approval-admin',
          i18nKey: 'route.manage_approval-admin',
          icon: 'mdi:cog',
          order: 11
        }
      },
      {
        name: 'manage_dict',
        path: '/manage/dict',
        component: 'view.manage_dict',
        meta: {
          title: 'manage_dict',
          i18nKey: 'route.manage_dict'
        }
      },
      {
        name: 'manage_menu',
        path: '/manage/menu',
        component: 'view.manage_menu',
        meta: {
          title: 'manage_menu',
          i18nKey: 'route.manage_menu',
          icon: 'material-symbols:route',
          order: 3,
          roles: ['R_ADMIN'],
          keepAlive: true
        }
      },
      {
        name: 'manage_notice',
        path: '/manage/notice',
        component: 'view.manage_notice',
        meta: {
          title: 'manage_notice',
          i18nKey: 'route.manage_notice'
        }
      },
      {
        name: 'manage_org',
        path: '/manage/org',
        component: 'view.manage_org',
        meta: {
          title: 'manage_org',
          i18nKey: 'route.manage_org'
        }
      },
      {
        name: 'manage_position',
        path: '/manage/position',
        component: 'view.manage_position',
        meta: {
          title: 'manage_position',
          i18nKey: 'route.manage_position'
        }
      },
      {
        name: 'manage_role',
        path: '/manage/role',
        component: 'view.manage_role',
        meta: {
          title: 'manage_role',
          i18nKey: 'route.manage_role',
          icon: 'carbon:user-role',
          order: 2,
          roles: ['R_SUPER']
        }
      },
      {
        name: 'manage_user',
        path: '/manage/user',
        component: 'view.manage_user',
        meta: {
          title: 'manage_user',
          i18nKey: 'route.manage_user',
          icon: 'ic:round-manage-accounts',
          order: 1,
          roles: ['R_ADMIN']
        }
      },
      {
        name: 'manage_user-detail',
        path: '/manage/user-detail/:id',
        component: 'view.manage_user-detail',
        props: true,
        meta: {
          title: 'manage_user-detail',
          i18nKey: 'route.manage_user-detail',
          hideInMenu: true,
          roles: ['R_ADMIN'],
          activeMenu: 'manage_user'
        }
      }
    ]
  },
  {
    name: 'millresident',
    path: '/millresident',
    component: 'layout.base',
    meta: {
      title: 'millresident',
      i18nKey: 'route.millresident'
    },
    children: [
      {
        name: 'millresident_unload-manifest',
        path: '/millresident/unload-manifest',
        component: 'view.millresident_unload-manifest',
        meta: {
          title: 'millresident_unload-manifest',
          i18nKey: 'route.millresident_unload-manifest'
        }
      }
    ]
  },
  {
    name: 'monitor',
    path: '/monitor',
    component: 'layout.base',
    meta: {
      title: 'monitor',
      i18nKey: 'route.monitor'
    },
    children: [
      {
        name: 'monitor_cache',
        path: '/monitor/cache',
        component: 'view.monitor_cache',
        meta: {
          title: 'monitor_cache',
          i18nKey: 'route.monitor_cache'
        }
      },
      {
        name: 'monitor_file',
        path: '/monitor/file',
        component: 'view.monitor_file',
        meta: {
          title: 'monitor_file',
          i18nKey: 'route.monitor_file'
        }
      },
      {
        name: 'monitor_logs',
        path: '/monitor/logs',
        meta: {
          title: 'monitor_logs',
          i18nKey: 'route.monitor_logs'
        },
        children: [
          {
            name: 'monitor_logs_error',
            path: '/monitor/logs/error',
            component: 'view.monitor_logs_error',
            meta: {
              title: 'monitor_logs_error',
              i18nKey: 'route.monitor_logs_error'
            }
          },
          {
            name: 'monitor_logs_login',
            path: '/monitor/logs/login',
            component: 'view.monitor_logs_login',
            meta: {
              title: 'monitor_logs_login',
              i18nKey: 'route.monitor_logs_login'
            }
          },
          {
            name: 'monitor_logs_operation',
            path: '/monitor/logs/operation',
            component: 'view.monitor_logs_operation',
            meta: {
              title: 'monitor_logs_operation',
              i18nKey: 'route.monitor_logs_operation'
            }
          },
          {
            name: 'monitor_logs_scheduler',
            path: '/monitor/logs/scheduler',
            component: 'view.monitor_logs_scheduler',
            meta: {
              title: 'monitor_logs_scheduler',
              i18nKey: 'route.monitor_logs_scheduler'
            }
          }
        ]
      },
      {
        name: 'monitor_scheduler',
        path: '/monitor/scheduler',
        component: 'view.monitor_scheduler',
        meta: {
          title: 'monitor_scheduler',
          i18nKey: 'route.monitor_scheduler'
        }
      },
      {
        name: 'monitor_system',
        path: '/monitor/system',
        component: 'view.monitor_system',
        meta: {
          title: 'monitor_system',
          i18nKey: 'route.monitor_system'
        }
      }
    ]
  },
  {
    name: 'multi-menu',
    path: '/multi-menu',
    component: 'layout.base',
    meta: {
      title: 'multi-menu',
      i18nKey: 'route.multi-menu',
      order: 8
    },
    children: [
      {
        name: 'multi-menu_first',
        path: '/multi-menu/first',
        meta: {
          title: 'multi-menu_first',
          i18nKey: 'route.multi-menu_first',
          order: 1
        },
        children: [
          {
            name: 'multi-menu_first_child',
            path: '/multi-menu/first/child',
            component: 'view.multi-menu_first_child',
            meta: {
              title: 'multi-menu_first_child',
              i18nKey: 'route.multi-menu_first_child'
            }
          }
        ]
      },
      {
        name: 'multi-menu_second',
        path: '/multi-menu/second',
        meta: {
          title: 'multi-menu_second',
          i18nKey: 'route.multi-menu_second',
          order: 2
        },
        children: [
          {
            name: 'multi-menu_second_child',
            path: '/multi-menu/second/child',
            meta: {
              title: 'multi-menu_second_child',
              i18nKey: 'route.multi-menu_second_child'
            },
            children: [
              {
                name: 'multi-menu_second_child_home',
                path: '/multi-menu/second/child/home',
                component: 'view.multi-menu_second_child_home',
                meta: {
                  title: 'multi-menu_second_child_home',
                  i18nKey: 'route.multi-menu_second_child_home'
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: 'nonbase-goods',
    path: '/nonbase-goods',
    component: 'layout.base',
    meta: {
      title: 'nonbase-goods',
      i18nKey: 'route.nonbase-goods'
    },
    children: [
      {
        name: 'nonbase-goods_factory-images',
        path: '/nonbase-goods/factory-images',
        component: 'view.nonbase-goods_factory-images',
        meta: {
          title: 'nonbase-goods_factory-images',
          i18nKey: 'route.nonbase-goods_factory-images'
        }
      },
      {
        name: 'nonbase-goods_factory-quality',
        path: '/nonbase-goods/factory-quality',
        component: 'view.nonbase-goods_factory-quality',
        meta: {
          title: 'nonbase-goods_factory-quality',
          i18nKey: 'route.nonbase-goods_factory-quality'
        }
      },
      {
        name: 'nonbase-goods_factory-weight',
        path: '/nonbase-goods/factory-weight',
        component: 'view.nonbase-goods_factory-weight',
        meta: {
          title: 'nonbase-goods_factory-weight',
          i18nKey: 'route.nonbase-goods_factory-weight'
        }
      },
      {
        name: 'nonbase-goods_measurement-tracking',
        path: '/nonbase-goods/measurement-tracking',
        component: 'view.nonbase-goods_measurement-tracking',
        meta: {
          title: 'nonbase-goods_measurement-tracking',
          i18nKey: 'route.nonbase-goods_measurement-tracking'
        }
      },
      {
        name: 'nonbase-goods_nonbase',
        path: '/nonbase-goods/nonbase',
        component: 'view.nonbase-goods_nonbase',
        meta: {
          title: 'nonbase-goods_nonbase',
          i18nKey: 'route.nonbase-goods_nonbase'
        }
      },
      {
        name: 'nonbase-goods_nonbase-waybill',
        path: '/nonbase-goods/nonbase-waybill',
        component: 'view.nonbase-goods_nonbase-waybill',
        meta: {
          title: 'nonbase-goods_nonbase-waybill',
          i18nKey: 'route.nonbase-goods_nonbase-waybill'
        }
      },
      {
        name: 'nonbase-goods_sales-detail-account',
        path: '/nonbase-goods/sales-detail-account',
        component: 'view.nonbase-goods_sales-detail-account',
        meta: {
          title: 'nonbase-goods_sales-detail-account',
          i18nKey: 'route.nonbase-goods_sales-detail-account'
        }
      },
      {
        name: 'nonbase-goods_steel-settlement',
        path: '/nonbase-goods/steel-settlement',
        component: 'view.nonbase-goods_steel-settlement',
        meta: {
          title: 'nonbase-goods_steel-settlement',
          i18nKey: 'route.nonbase-goods_steel-settlement'
        }
      },
      {
        name: 'nonbase-goods_tracks-delivery',
        path: '/nonbase-goods/tracks-delivery',
        component: 'view.nonbase-goods_tracks-delivery',
        meta: {
          title: 'nonbase-goods_tracks-delivery',
          i18nKey: 'route.nonbase-goods_tracks-delivery'
        },
        children: [
          {
            name: 'nonbase-goods_tracks-delivery_detail',
            path: '/nonbase-goods/tracks-delivery/detail',
            component: 'view.nonbase-goods_tracks-delivery_detail',
            meta: {
              title: 'nonbase-goods_tracks-delivery_detail',
              i18nKey: 'route.nonbase-goods_tracks-delivery_detail'
            }
          }
        ]
      }
    ]
  },
  {
    name: 'price',
    path: '/price',
    component: 'layout.base',
    meta: {
      title: 'price',
      i18nKey: 'route.price'
    },
    children: [
      {
        name: 'price_disposal-material',
        path: '/price/disposal-material',
        component: 'view.price_disposal-material',
        meta: {
          title: 'price_disposal-material',
          i18nKey: 'route.price_disposal-material'
        }
      },
      {
        name: 'price_material',
        path: '/price/material',
        component: 'view.price_material',
        meta: {
          title: 'price_material',
          i18nKey: 'route.price_material'
        }
      },
      {
        name: 'price_material-maintenance',
        path: '/price/material-maintenance',
        component: 'view.price_material-maintenance',
        meta: {
          title: 'price_material-maintenance',
          i18nKey: 'route.price_material-maintenance'
        }
      }
    ]
  },
  {
    name: 'report',
    path: '/report',
    component: 'layout.base',
    meta: {
      title: 'report',
      i18nKey: 'route.report'
    },
    children: [
      {
        name: 'report_daily-business-report-2',
        path: '/report/daily-business-report-2',
        component: 'view.report_daily-business-report-2',
        meta: {
          title: 'report_daily-business-report-2',
          i18nKey: 'route.report_daily-business-report-2'
        },
        children: [
          {
            name: 'report_daily-business-report-2_scrap-business-report',
            path: '/report/daily-business-report-2/scrap-business-report',
            component: 'view.report_daily-business-report-2_scrap-business-report',
            meta: {
              title: 'report_daily-business-report-2_scrap-business-report',
              i18nKey: 'route.report_daily-business-report-2_scrap-business-report'
            }
          }
        ]
      },
      {
        name: 'report_factory-daily-report',
        path: '/report/factory-daily-report',
        component: 'view.report_factory-daily-report',
        meta: {
          title: 'report_factory-daily-report',
          i18nKey: 'route.report_factory-daily-report'
        }
      },
      {
        name: 'report_measurement-daily-report',
        path: '/report/measurement-daily-report',
        component: 'view.report_measurement-daily-report',
        meta: {
          title: 'report_measurement-daily-report',
          i18nKey: 'route.report_measurement-daily-report'
        }
      },
      {
        name: 'report_sales-performance',
        path: '/report/sales-performance',
        component: 'view.report_sales-performance',
        meta: {
          title: 'report_sales-performance',
          i18nKey: 'route.report_sales-performance'
        }
      },
      {
        name: 'report_scrap-business-report',
        path: '/report/scrap-business-report',
        component: 'view.report_scrap-business-report',
        meta: {
          title: 'report_scrap-business-report',
          i18nKey: 'route.report_scrap-business-report'
        }
      },
      {
        name: 'report_weekly-business-report',
        path: '/report/weekly-business-report',
        component: 'view.report_weekly-business-report',
        meta: {
          title: 'report_weekly-business-report',
          i18nKey: 'route.report_weekly-business-report'
        }
      }
    ]
  },
  {
    name: 'settlement',
    path: '/settlement',
    component: 'layout.base',
    meta: {
      title: 'settlement',
      i18nKey: 'route.settlement'
    },
    children: [
      {
        name: 'settlement_purchase-settlement',
        path: '/settlement/purchase-settlement',
        component: 'view.settlement_purchase-settlement',
        meta: {
          title: 'settlement_purchase-settlement',
          i18nKey: 'route.settlement_purchase-settlement'
        },
        children: [
          {
            name: 'settlement_purchase-settlement_review',
            path: '/settlement/purchase-settlement/review',
            component: 'view.settlement_purchase-settlement_review',
            meta: {
              title: 'settlement_purchase-settlement_review',
              i18nKey: 'route.settlement_purchase-settlement_review'
            }
          }
        ]
      },
      {
        name: 'settlement_purchase-settlement-center',
        path: '/settlement/purchase-settlement-center',
        component: 'view.settlement_purchase-settlement-center',
        meta: {
          title: 'settlement_purchase-settlement-center',
          i18nKey: 'route.settlement_purchase-settlement-center'
        }
      },
      {
        name: 'settlement_sales-settlement',
        path: '/settlement/sales-settlement',
        component: 'view.settlement_sales-settlement',
        meta: {
          title: 'settlement_sales-settlement',
          i18nKey: 'route.settlement_sales-settlement'
        }
      },
      {
        name: 'settlement_sales-settlement-center',
        path: '/settlement/sales-settlement-center',
        component: 'view.settlement_sales-settlement-center',
        meta: {
          title: 'settlement_sales-settlement-center',
          i18nKey: 'route.settlement_sales-settlement-center'
        }
      }
    ]
  },
  {
    name: 'tools',
    path: '/tools',
    component: 'layout.base',
    meta: {
      title: 'tools',
      i18nKey: 'route.tools'
    },
    children: [
      {
        name: 'tools_generate-table',
        path: '/tools/generate-table',
        component: 'view.tools_generate-table',
        meta: {
          title: 'tools_generate-table',
          i18nKey: 'route.tools_generate-table'
        }
      }
    ]
  },
  {
    name: 'unified-management',
    path: '/unified-management',
    component: 'layout.base',
    meta: {
      title: 'unified-management',
      i18nKey: 'route.unified-management'
    },
    children: [
      {
        name: 'unified-management_facility',
        path: '/unified-management/facility',
        component: 'view.unified-management_facility',
        meta: {
          title: 'unified-management_facility',
          i18nKey: 'route.unified-management_facility'
        }
      },
      {
        name: 'unified-management_files',
        path: '/unified-management/files',
        component: 'view.unified-management_files',
        meta: {
          title: 'unified-management_files',
          i18nKey: 'route.unified-management_files'
        }
      },
      {
        name: 'unified-management_purchase',
        path: '/unified-management/purchase',
        component: 'view.unified-management_purchase',
        meta: {
          title: 'unified-management_purchase',
          i18nKey: 'route.unified-management_purchase'
        }
      },
      {
        name: 'unified-management_sales',
        path: '/unified-management/sales',
        component: 'view.unified-management_sales',
        meta: {
          title: 'unified-management_sales',
          i18nKey: 'route.unified-management_sales'
        }
      }
    ]
  },
  {
    name: 'user-center',
    path: '/user-center',
    component: 'layout.base$view.user-center',
    meta: {
      title: 'user-center',
      i18nKey: 'route.user-center'
    }
  }
];
